import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Title } from '@angular/platform-browser';

@Injectable()
export class BuNameService {

  private buNameObject: any = { name: "", url : "", img : ""}
  private buName: Subject<any> = new Subject<any>();
  public  buName$: Observable<any> = this.buName.asObservable();

  constructor(
    private titleService: Title
  ) { }

  /**
   * Nom de la BU dans le header
   */
  set name(name: string){
    this.buNameObject.name = name
    this.buName.next(this.buNameObject);
  }

  /**
   * Lien de l'url au cilck sur le logo
   */
  set url(url: string){
    this.buNameObject.url = url
    this.buName.next(this.buNameObject);
  }

  /**
   * Le chemin vers le fichier de l'image
   */
  set img(filename: string){
    let path = (filename == "default") ? "/assets/img/logo-orange.jpg" : filename ;
    this.buNameObject.img = path
    this.buName.next(this.buNameObject);
  }

  /**
   * Change le title du site
   */
  set title(title: string){
    this.titleService.setTitle("Module d'inscription Orange - " + title); 
  }
}



// WEBPACK FOOTER //
// ./src/app/helper/core/bu-name.service.ts